export default "__VITE_ASSET__CVx$w6DZ__"